<template>
  <v-container grid-list-md fluid ma-3 text-xs-center>
    <v-layout justify-center wrap row>
      <v-flex xs8 style="max-width:550px">
        <v-flex xs12 text-xs-center headline ma-3>
          Reset your password.
        </v-flex>
        <v-container fluid pa-5 elevation-1>
          <form v-on:keyup.enter="setPassword">
            <v-layout column wrap>
              <v-flex xs12 mb-4 v-if="error">
                <v-alert
                  :value="error"
                  type="error"
                  outline
                >
                  {{ error }}
                </v-alert>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  outline
                  color="secondary"
                  label="Password"
                  type="password"
                  v-model="password"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  outline
                  color="secondary"
                  label="Confirm Password"
                  type="password"
                  v-model="password2"
                  :rules="[rules.required]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 mt-1 text-xs-center>
                <v-btn class="secondary ma-0"
                  v-if="!loading"
                  dark
                  @click="setPassword">Submit</v-btn>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="secondary"
                ></v-progress-circular>
              </v-flex>
            </v-layout>
          </form>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      loading: false,
      error: null,
      code: null,
      password: null,
      password2: null,
      rules: {
          required: value => !!value || 'Required.'
      }
    }
  },
  components: {
  },
  methods: {
    async setPassword () {
      if (this.password !== this.password2) {
        this.error = 'Both passwords must match'
        return;
      }

      this.error = null
      this.loading = true
      try {
        const code = this.$route.params.code;
        const response = await AuthenticationService.recoverPassword({
          code: code,
          password: this.password
        })

        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)

        if (response.data.user.needsVerification) {
          this.$router.push({
            path: '/verify'
          })
        } else if (this.$store.getters.loginRedirect) {
          const redirect = this.$store.getters.loginRedirect;
          
          this.$store.dispatch('setLoginRedirect', null)

          this.$router.push({
            path: redirect.path
          })
        } else {
          this.$router.push({
            name: 'root'
          })
        }
      } catch(err) {
        this.error = err.response.data.error;
      }

      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>

